import React, {useEffect} from 'react';

import Button, {ButtonSizes} from '../../components/ButtonNew';
import DocumentHeader from '../../components/DocumentHeader';
import {useAnalytics} from '../../hooks';

import FAQs from './SupportFAQs';

const SupportPage = () => {
  const {tracker} = useAnalytics();

  useEffect(() => {
    tracker.supportView();
  }, []);

  return (
    <div className="pt-4 max-w-4xl mx-auto text-center md:text-left">
      <DocumentHeader title="Support and FAQ" />
      <h1 className="my-4 text-center md:text-left text-2xl md:text-4xl font-bold text-black">
        Frequently Asked Questions
      </h1>
      <FAQs />
      <div className="flex flex-col items-center">
        <span className="mb-2 text-lg font-medium text-gray-700">
          Still have questions?
        </span>
        <Button href="mailto:support@aced.io" size={ButtonSizes.LARGE}>
          Contact support
        </Button>
      </div>
    </div>
  );
};

export default SupportPage;
